import { Conflict } from '@/types/Conflicten';
import { Defect } from '@/types/Defecten';

import { VoorraadMapMaterieel } from '../state/types/VoorraadbeheerStore';
import { Reserve } from '../types';

import usePlankTableStore from './usePlankTableStore';

export default function useTable(matType: string): {
  mancos: Conflict[];
  verkeerdMat: Conflict[];
  defectenInzetbaar: Defect[];
  defectenBeperktInzetbaar: Defect[];
  defectenNietInzetbaar: Defect[];
  defectenInOnderhoud: Defect[];
  reserves: Reserve[];
  voorraadMaterieel: VoorraadMapMaterieel;
} {
  const mancos = usePlankTableStore((state) => state.mancosPerMaterieel?.[matType] ?? []);
  const verkeerdMat = usePlankTableStore((state) => state.verkeerdMatPerMaterieel?.[matType] ?? []);
  const defectenInzetbaar = usePlankTableStore((state) => state.defectenInzetbaarPerMaterieel?.[matType] ?? []);
  const defectenBeperktInzetbaar = usePlankTableStore(
    (state) => state.defectenBeperkInzetbaarPerMaterieel?.[matType] ?? [],
  );
  const defectenNietInzetbaar = usePlankTableStore((state) => state.defectenNietInzetbaarPerMaterieel?.[matType] ?? []);
  const defectenInOnderhoud = usePlankTableStore((state) => state.defectenInOnderhoudPerMaterieel?.[matType] ?? []);
  const reserves = usePlankTableStore((state) => state.reservesPerMaterieel?.[matType] ?? []);
  const voorraadMaterieel = usePlankTableStore((state) => state.getVoorraadMaterieel(matType));

  return {
    mancos,
    verkeerdMat,
    defectenInzetbaar,
    defectenBeperktInzetbaar,
    defectenNietInzetbaar,
    defectenInOnderhoud,
    reserves,
    voorraadMaterieel,
  };
}
